import React from "react";
import TopDonors from "../components/topDonors";
import { GetServerSideProps } from "next";
import {
  customGetServerSidePropsData,
  customGetServerSidePropsWithoutRequest,
} from "../utils/misc";
import Head from "next/head";

const TopDonorPage = ({ initialData }) => {
  let parseInitialData;
  try {
    parseInitialData = JSON.parse(initialData.query);
  } catch (e) {
    console.error(e);
  }
  const titleParser = "100 активных доноров за год и за всё время";
  const description =
    "Сдайте кровь, загрузите справку и ищите себя в топе! Рейтинг доноров крови.";
  const image = "/static/images/top/topDonorImage.jpeg";
  const IWidth = "600";
  const IHeight = "315";

  return (
    <>
      <Head>
        <title>{titleParser}</title>
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="vk:image" content={image} />
        <meta property="twitter:image" content={image} />
        <meta property="og:image" content={image} />
        <meta property="og:image:width" content={IWidth} />
        <meta property="og:image:height" content={IHeight} />
        <meta property="og:title" content={titleParser} />
        <meta property="og:description" content={description} />
        <meta name="description" content={description} />
        <link rel="image_src" href={image} />
        <meta name="twitter:card" content="summary_large_image" />
      </Head>
      <TopDonors initialData={parseInitialData} />
    </>
  );
};

const parseItemsLikeCity = (query) => {
  let returnValue = query;
  if (query.country) {
    returnValue.country = {
      label: query.country.title,
      value: +query.country.id,
    };
  }
  if (query.region) {
    returnValue.region = { label: query.region.title, value: +query.region.id };
  }
  if (query.city) {
    returnValue.city = { label: query.city.title, value: +query.city.id };
  }
  if (query.blood_station_id) {
    returnValue.blood_station_id = {
      label: query.blood_station_id.title,
      value: +query.blood_station_id.id,
    };
  }
  if (query.organization_id) {
    returnValue.organization_id = {
      label: query.organization_id.title,
      value: +query.organization_id.id,
    };
  }
  return returnValue;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const res = await customGetServerSidePropsData(
    `/api/place/${context.resolvedUrl.replace("/top/", "")}`,
    context
  );

  const query = parseItemsLikeCity({ ...context.query, ...res });

  return await customGetServerSidePropsWithoutRequest({
    initialData: { query: JSON.stringify(query) },
  });
};

export default TopDonorPage;
